<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editOrganisation" :validation-schema="OrganisationSchema">
        <div class="row">
          <!-- Titre -->
          <div class="col-md-6">
            <div class="form-group mb-15">
              <label class="d-block text-black fw-semibold mb-10">
                Titre <span class="text-danger">*</span>
              </label>
              <Field
                name="titre"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.titre"
              />
              <ErrorMessage name="titre" class="text-danger"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15">
              <label class="d-block text-black fw-semibold mb-10">Image principale</label>
              <input
                ref="imageInput"
                type="file"
                name="image"
                accept="image/jpeg, image/png"
                class="form-control shadow-none fs-md-15 text-black"
              />
              <ErrorMessage name="urlImage" class="text-danger"/>
            </div>
          </div>
          

          <!-- Menu parent -->
          <div class="col-md-6">
            <div class="form-group mb-15">
              <label class="d-block text-black fw-semibold mb-10">
                Organisation Parent
              </label>
              <Field name="organisationId" v-slot="{ field }">
                <Multiselect
                  :options="OrganisationOptions"
                  v-model="selectedParentId"
                  track-by="value"
                  label="label"
                  placeholder="Sélectionner une organisation parent"
                  :can-clear="true"
                  @change="field.onChange($event)"
                />
              </Field>
              <ErrorMessage name="organisationId" class="text-danger" />
            </div>
          </div>

          <!-- Categorie Articles -->
          <div class="col-md-6">
            <div class="form-group mb-15">
              <label class="d-block text-black fw-semibold mb-10">
                Catégories
              </label>
              <Field name="categorieId" v-slot="{ field }" v-model="selectedCategorieIds">
                <Multiselect
                  :options="categorieArticlesOptions"
                 
                  track-by="value"
                  label="label"
                  mode="tags"
                  placeholder="Sélectionner des catégories"
                  @select="field.onChange(selectedCategorieIds)"
                  @remove="field.onChange(selectedCategorieIds)"
                />
              </Field>
              <ErrorMessage name="categorieId" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
                <div class="mb-0">
                    <QuillEditor
                        v-model:content="formData.description"
                        toolbar="full"
                        contentType="html"
                        theme="snow"
                        placeholder="Écrivez la description"
                    />

                </div>
              <ErrorMessage name="description" class="text-danger"/>
            </div>
          </div>
          <!-- Boutons -->
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button type="submit"
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success">
                Modifier
              </button>
              <router-link to="/liste-organisations" class="btn btn-danger transition border-0">
                Annuler
              </router-link>
            </div>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import Multiselect from '@vueform/multiselect'
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
import { url } from "inspector";

export default defineComponent({
  name: "EditOrganisation",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const organisationId = Number(route.params.id);

    const OrganisationSchema = Yup.object().shape({
      titre: Yup.string().required("Le titre est obligatoire"),
      image: Yup.mixed().notRequired(),
      urlImage:Yup.mixed().notRequired(),
    });
    const formData = reactive({
      titre: "",
      description: "",
      urlImage: null as File | null,
    })

    const selectedParentId = ref<number | null>(null);
    const selectedCategorieIds = ref<number[]>([]);
    const OrganisationOptions = ref([]);
    const categorieArticlesOptions = ref<any[]>([]);
    const imageInput = ref<HTMLInputElement | null>(null);

    const fetchOrganisations = async () => {
      try {
        const response = await ApiService.get('/organisations');
        const organisationsData = response.data.data.data;
        OrganisationOptions.value = organisationsData.map((organisation) => ({
          value: organisation.id,
          label: `${organisation.titre}`
        }));

      } catch (error) {
        //
      }
    };

    const fetchCategorieArticles = async () => {
      try {
        const response = await ApiService.get('/categorieArticles');
        const categorieData = response.data.data.data;
        const categoriesData = categorieData.filter(
          (categorie: any) => categorie.isService === "Non"
        );
        categorieArticlesOptions.value = categoriesData.map((cat) => ({
          value: cat.id,
          label: `${cat.nom}`,
        }));
      } catch (error) {
        console.error(error);
      }
    };

    const getOrganisation = async (id: number) => {
      try {
        const res = await ApiService.get(`/organisation/${id}`);
        const organisation = res.data.data;
        console.log('uuuuuu',organisation)
        formData.titre = organisation.titre || "";
        formData.description = organisation.description || "";

        selectedParentId.value = organisation.organisation?.id || null;
        selectedCategorieIds.value = organisation.categorieArticles?.map((c: any) => c.id) || [];

      } catch (err: any) {
        console.error(err);
        error(err.response?.data?.message || "Erreur lors du chargement de organisation");
      }
    };

    const editOrganisation = async () => {
      try {
        const fd = new FormData();
        fd.append("titre", formData.titre);
        fd.append("description", formData.description);

        if (selectedParentId.value) fd.append("parentId", selectedParentId.value.toString());
        if (selectedCategorieIds.value.length > 0) {
            fd.append("categorieId", selectedCategorieIds.value[0].toString());
        }

        if (imageInput.value?.files?.[0]) fd.append("urlImage", imageInput.value.files[0]);
    
        const res = await ApiService.put(`/organisations/${organisationId}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });


        if (res.data.code === 200) {
          success(res.data.message);
          router.push("/liste-organisations");
        }
      } catch (err: any) {
        console.error(err);
        error(err.response?.data?.message || "Erreur lors de la modification");
      }
    };
    onMounted(() => {
      if (organisationId && !isNaN(organisationId)) getOrganisation(organisationId);
      fetchCategorieArticles(),
       fetchOrganisations()
    },
      )
    

    return {
      OrganisationSchema,
      formData,
      editOrganisation,
      selectedParentId,
      selectedCategorieIds,
      OrganisationOptions,
      categorieArticlesOptions,
      imageInput,
    };
  }
});
</script>
